/* 开发环境地址配置 */
const dev = {
  //模拟接口
  // baseUrl: "https://eshop.hnxheshop.com/eshop", //湖南
  // orgid : 'kx9b89y2sf',
  // PName:'会员中心',
  // userId:"admin_h5",
  // passwd:"admin_h5666",
  // companyId:'',
  // wxAppid:'wxedcda045eb56bf43',
  // isWx:false
    //江西西店
  // baseUrl: "http://www.91bke.com/eshop",//陕西西店
  // orgid:'gpx008d5n1',//陕西西店
  // wxAppid:'wx3e95daee9a0f990b',//陕西西店
  // uploadUrl: "",
  // downloadUrl: "",
  // 
  // 测试
    baseUrl: "https://eshop.91onix.com/eshop",
    uploadUrl: "",
    downloadUrl: "",
    orgid : 'is4ubnnpos',
    wxAppid:'wx63d3326ef687a1e6',
    userId:"0006",
    passwd:"123456",
    shareUrl:"http://crm-test.91bke.com/",
    PName:'会员中心',
      base:'',
      isWx:false
    // 天津
    // baseUrl: "http://erp.tjbb.com/eshop",
    // uploadUrl: "",
    // downloadUrl: "",
    // orgid : 'uusb1xifhp',
    // wxAppid:'',
    // userId:"tjtsds2020",
    // passwd:"e123456",
    // shareUrl:"http://crm-test.91bke.com/",
    // companyId:'smy9hbmok5',
    // PName:'天津图书大厦',
    // base:'',
    // isWx:false
  // 河北
  // baseUrl: "https://www.xinhuabesthy.com/eshop",//河北
  // orgid : 'o0htbyv43b',//河北
  // wxAppid:'wx7a702b995d174ba5', //河北
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"crmhb",
  // passwd:"123456",
  // shareUrl:"https://wx.xinhuabesthy.com/",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:false,
  // 江苏常测试
  // baseUrl: "http://postest.ppm.cn/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : '9040',
  // wxAppid:'wx63d3326ef687a1e6',
  // userId:"admin_fh",
  // passwd:"fhcm185",
  // shareUrl:"http://pos.ppm.cn/",
  // PName:'会员中心',
  // base:'',
  // baseUrl: "https://pxh.jsbooks.com.cn/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : '9040',
  // wxAppid:'wxfdd72786f50895c1',
  // userId:"admin_fh",
  // passwd:"fhcm185",
  // shareUrl:"https://pxh.jsbooks.com.cn/crm",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:false

  //   baseUrl: "http://www.91bke.com/eshop",//陕西西店
  // orgid:'gpx008d5n1',//陕西西店
  // wxAppid:'wx3e95daee9a0f990b',//陕西西店
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"admin_sx",
  // passwd:"sxxd123"
  // 甘肃
  // baseUrl: "https://eshopwx.gsxhsd.com/eshop",//河北
  // orgid : 't00vvxzw4a',//河北
  // wxAppid:'wx0984cd78d4181521', //河北
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"token",
  // passwd:"zq88389223",
  // shareUrl:"https://eshopwx.gsxhsd.com/crm",
  // companyId:'gah5xggo6w',
  // PName:'会员中心',
  // base:'',
  // isWx:false
  // 江西
  // baseUrl: "https://crmwx.jxxhsd.com/eshop",//江西
  // orgid : '67np5a0t7j',//江西
  // wxAppid:'wxce286bc9cedd54e5', //江西
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"admin_01",
  // passwd:"jxxh666",
  // shareUrl:"https://crmwx.jxxhsd.com/",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:false
}

/**
 * 模拟真实接口
 * @type {Object}
 */
const prod = {
  //正式接口
  // baseUrl: "https://eshop.hnxheshop.com/eshop", //湖南
  // orgid : 'kx9b89y2sf',
  // PName:'会员中心',
  // userId:"admin_h5",
  // passwd:"admin_h5666",
  // companyId:'',
  // wxAppid:'wxedcda045eb56bf43',
  // base:'',
  // isWx:false
// 甘肃
  // baseUrl: "https://eshopwx.gsxhsd.com/eshop",//甘肃
  // orgid : 't00vvxzw4a',//甘肃
  // wxAppid:'wx0984cd78d4181521', //甘肃
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"token",
  // passwd:"zq88389223",
  // shareUrl:"https://eshopwx.gsxhsd.com/crm",
  // companyId:'gah5xggo6w',
  // PName:'会员中心',
  // base:'',
  // isWx:true
  // 河北
  baseUrl: "https://www.xinhuabesthy.com/eshop",//河北
  orgid : 'o0htbyv43b',//河北
  wxAppid:'wx7a702b995d174ba5', //河北
  uploadUrl: "",
  downloadUrl: "",
  userId:"crmhb",
  passwd:"123456",
  shareUrl:"https://wx.xinhuabesthy.com/",
  companyId:'',
  PName:'会员中心',
  base:'',
  isWx:true
  // 江苏
  // baseUrl: "https://pxh.jsbooks.com.cn/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : '9040',
  // wxAppid:'wxfdd72786f50895c1',
  // userId:"admin_fh",
  // passwd:"fhcm185",
  // shareUrl:"https://pxh.jsbooks.com.cn/crm",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:true

  // baseUrl: "http://postest.ppm.cn/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : '9040',
  // wxAppid:'wx63d3326ef687a1e6',
  // userId:"admin_fh",
  // passwd:"fhcm185",
  // shareUrl:"http://pos.ppm.cn/",
  // PName:'会员中心',
  // base:'crm',
  // isWx:false

  //江西西店
  // baseUrl: "http://www.91bke.com/eshop",//陕西西店
  // orgid:'gpx008d5n1',//陕西西店
  // wxAppid:'wx3e95daee9a0f990b',//陕西西店
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"admin_sx",
  // passwd:"sxxd123",
  // shareUrl:"http://www.91bke.com/usercenter/xd"

  // 测试
  // baseUrl: "https://eshop.91onix.com/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : 'is4ubnnpos',
  // wxAppid:'wx63d3326ef687a1e6',
  // userId:"0006",
  // passwd:"123456",
  // shareUrl:"http://crm-test.91bke.com/",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:true
  // 江西
  // 江西
  // baseUrl: "https://crmwx.jxxhsd.com/eshop",//江西
  // orgid : '67np5a0t7j',//江西
  // wxAppid:'wxce286bc9cedd54e5', //江西
  // uploadUrl: "",
  // downloadUrl: "",
  // userId:"admin_01",
  // passwd:"jxxh666",
  // shareUrl:"https://crmwx.jxxhsd.com/",
  // companyId:'',
  // PName:'会员中心',
  // base:'',
  // isWx:false
  //   // 江苏长测试
  // baseUrl: "http://postest.ppm.cn/eshop",
  // uploadUrl: "",
  // downloadUrl: "",
  // orgid : '9040',
  // wxAppid:'wx63d3326ef687a1e6',
  // userId:"zoumindong",
  // passwd:"e123456",
  // shareUrl:"http://crm-test.91bke.com"
  // 天津
    // baseUrl: "http://erp.tjbb.com/eshop",
    // uploadUrl: "",
    // downloadUrl: "",
    // orgid : 'uusb1xifhp',
    // wxAppid:'',
    // userId:"tjtsds2020",
    // passwd:"e123456",
    // shareUrl:"http://crm-test.91bke.com/",
    // companyId:'smy9hbmok5',
    // PName:'天津图书大厦',
    // base:'crm',
    // isWx:false
}

/* 生产环境地址配置 */
// const prod = {
//   baseUrl: "https://www.91bke.com/eshop",
//   uploadUrl: "",
//   downloadUrl: "",
//   orgid : 'dk4j82dlqn'
// }

const env = process.env.NODE_ENV

let Api

if (env === 'development') {
  Api = dev
} else {
  Api = prod
}


export default Api



// WEBPACK FOOTER //
// ./src/config/index.js